<template>
  <div>
    <md-progress-bar v-if="loading" md-mode="indeterminate"></md-progress-bar>

    <md-empty-state
      v-if="!reception"
      md-icon="whatshot"
      md-label="Нет задач по приемке"
      md-description="Нет задач по приемке"
    ></md-empty-state>

    <div v-if="reception" class="md-layout">
      <div class="md-layout-item receptions-table-container">
        <div class="receptions-title">
          <span class="md-body-2">
            Прием товара: {{ reception.order_number }} ({{
              cell ? cell.message : "Ячейка не выбрана"
            }})
          </span>
          <span class="md-body-1">Добавлено {{ fact }} из {{ plan }}</span>
        </div>

        <md-content class="md-layout receptions-mobile-table">
          <div class="md-layout-item md-size-100">
            <md-table md-card class="md-scrollbar custom-table">
              <md-table-row>
                <md-table-head>Продукт</md-table-head>
                <md-table-head :style="{ lineHeight: '16px' }">
                  Запр.
                  <br />
                  Факт
                </md-table-head>
                <md-table-head>Пост.</md-table-head>
              </md-table-row>

              <md-table-row
                v-for="item in reception.products"
                v-on:select="onSelect(item)"
                v-on:click="onSelect(item)"
                v-bind:key="item.article + item.size"
                slot="md-table-row"
                :class="getClass(item)"
                :ref="item.article + item.size"
              >
                <md-table-cell md-label="Продукт">
                  {{ item.name }} ({{ item.size.toUpperCase() }})
                </md-table-cell>
                <md-table-cell md-label="Запрошено | Факт">
                  {{ item.quantity_plan }} | {{ item.quantity_fact }}
                </md-table-cell>
                <md-table-cell md-label="Поставщик">
                  {{ item.provider_name }}
                </md-table-cell>
              </md-table-row>
            </md-table>
          </div>
        </md-content>
        <md-content class="md-layout receptions-table">
          <div class="md-layout-item md-size-100">
            <md-table
              md-card
              class="md-scrollbar"
              :style="{
                overflow: 'auto',
                maxHeight: this.window.height - 130 + 'px',
              }"
            >
              <md-table-row>
                <md-table-head>Артикл</md-table-head>
                <md-table-head>Продукт</md-table-head>
                <md-table-head>Размер</md-table-head>
                <md-table-head>Запрошено</md-table-head>
                <md-table-head>Факт</md-table-head>
                <md-table-head>Поставщик</md-table-head>
              </md-table-row>

              <md-table-row
                v-for="item in reception.products"
                v-on:select="onSelect(item)"
                v-on:click="onSelect(item)"
                :key="item.article + item.size"
                slot="md-table-row"
                :class="getClass(item)"
                :ref="item.article + item.size"
              >
                <md-table-cell md-label="Артикл">
                  {{ item.article }}
                </md-table-cell>
                <md-table-cell md-label="Продукт">
                  {{ item.name }}
                </md-table-cell>
                <md-table-cell md-label="Размер">{{ item.size }}</md-table-cell>
                <md-table-cell md-label="Запрошено">
                  {{ item.quantity_plan }}
                </md-table-cell>
                <md-table-cell md-label="Факт">
                  {{ item.quantity_fact }}
                </md-table-cell>
                <md-table-cell md-label="Поставщик">
                  {{ item.provider_name }}
                </md-table-cell>
              </md-table-row>
            </md-table>
          </div>
        </md-content>
      </div>
      <div v-if="selected" class="md-layout-item receptions-image">
        <img
          v-touch:swipe="imageSwipeHandler"
          v-on:click="imageClickHandler"
          :src="image"
          :alt="selected.name"
        />
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: "Receptions",
    data: () => ({
      image: null,
      window: {
        width: null,
        height: null,
      },
      loading: false,
    }),
    created() {
      window.addEventListener("resize", this.handleResize);
      this.handleResize();
    },
    destroyed() {
      window.removeEventListener("resize", this.handleResize);
    },
    mounted() {
      this.image = this.holder;
      this.processImage();
      this.processScroll();
    },
    watch: {
      selected() {
        this.processImage();
        this.processScroll();
      },
    },
    computed: {
      cell() {
        return this.$store.state.receptions.cell;
      },
      plan() {
        return this.$store.state.receptions.item.products.reduce(
          (a, b) => a + (b.quantity_plan || 0),
          0
        );
      },
      fact() {
        return this.$store.state.receptions.item.products.reduce(
          (a, b) => a + (b.quantity_fact || 0),
          0
        );
      },
      selected() {
        return this.$store.state.receptions.selected;
      },
      holder() {
        return this.$store.state.holder.item;
      },
      reception() {
        return this.$store.state.receptions.item;
      },
    },
    methods: {
      processScroll() {
        if (this.selected) {
          this.$refs[
            this.selected.article + this.selected.size
          ][0].$el.scrollIntoView({ behavior: "smooth" });
        }
      },
      handleResize() {
        this.window.width = window.innerWidth;
        this.window.height = window.innerHeight;
      },
      processImage() {
        this.image = this.holder;

        const path = this.selected.images.big[0];
        new Promise((resolve, reject) => {
          const img = new Image();

          img.onload = () => resolve();

          img.onerror = () => reject();

          img.src = path;
        })
          .then(() => {
            this.image = path;
          })
          .catch((error) => {
            console.error(error);
            this.$store.commit("messages/setMessage", {
              type: "warning",
              code: "Ой вей!",
              message: "Картинка к товару не была загружена",
            });
          });
      },
      getClass(item) {
        if (this.selected) {
          if (
            item.article === this.selected.article &&
            item.size === this.selected.size
          ) {
            return "md-primary md-has-selection md-selected-single";
          }

          if (
            item.quantity_plan !== item.quantity_fact &&
            item !== this.selected
          )
            return "md-accent md-has-selection md-selected-single";
        }
      },
      onSelect(item) {
        this.$store.commit("receptions/setSelected", item);
      },
      imageClickHandler() {
        this.imageSwipeHandler("right");
      },
      imageSwipeHandler(direction) {
        const index = this.selected.images.big.indexOf(this.image);

        if (direction === "right") {
          if (index - 1 >= 0) {
            this.image = this.selected.images.big[index - 1];
          } else {
            this.image = this.selected.images.big[
              this.selected.images.big.length - 1
            ];
          }
        }

        if (direction === "left") {
          if (index + 1 <= this.selected.images.big.length - 1) {
            this.image = this.selected.images.big[index + 1];
          } else {
            this.image = this.selected.images.big[0];
          }
        }
      },
    },
  };
</script>

<style lang="scss" scope>
  .receptions-table {
    @media (max-width: 960px) {
      display: none !important;
    }
  }

  .receptions-mobile-table {
    display: none !important;
    @media (max-width: 960px) {
      display: flex !important;
    }
  }

  .receptions-title {
    display: flex;
    justify-content: space-between;
    padding: 8px 16px;
    width: 100%;
    @media (max-width: 460px) {
      flex-direction: column;
    }
  }

  .md-layout-item.receptions-table-container {
    min-width: 75%;
    max-width: 75%;
    flex: 0 1 75%;
    @media (max-width: 460px) {
      min-width: 100%;
      max-width: 100%;
      flex: 0 1 100%;
    }
  }

  .receptions-image {
    flex: 1 1;
    height: calc(100vh - 52px);
    overflow: hidden;
    @media (max-width: 780px) {
      height: calc(100vh - 65px);
    }

    @media (max-width: 460px) {
      display: none;
    }
  }

  .custom-table {
    overflow: auto !important;
    max-height: calc(100vh - 88px);
    margin-right: 0px !important;
    margin-left: 0px !important;
    @media (max-width: 460px) {
      max-height: calc(100vh - 116px);
    }
  }
</style>

<style lang="scss">
  .md-table-cell > .md-table-cell-container {
    @media (max-width: 500px) {
      padding: 6px 16px;
    }
  }
</style>
